import { Link } from 'react-router-dom';
import { apps } from '@/mocks/data';

export default function FeaturedApps() {
  const featured = apps.slice(0, 6);

  return (
    <section className="py-16 md:py-20 px-6 md:px-10 bg-background-50">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-12">
          <span className="inline-block px-3 py-1 rounded-full bg-accent-100 text-accent-700 text-xs font-medium mb-3 whitespace-nowrap">
            热门推荐
          </span>
          <h2 className="text-2xl md:text-3xl font-bold text-foreground-950 mb-3">
            热门体育App推荐
          </h2>
          <p className="text-sm text-foreground-600 max-w-lg mx-auto">
            精选用户评分最高、下载量最大的体育应用，助你快速锁定优质App
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
          {featured.map((app) => (
            <Link
              key={app.id}
              to={`/article/${app.articleId}`}
              className="group bg-background-50 border border-background-200/70 rounded-xl p-5 hover:border-accent-200 transition-all duration-200 cursor-pointer"
              data-product-shop=""
            >
              <div className="flex items-start gap-4">
                <div className="w-14 h-14 md:w-16 md:h-16 rounded-2xl overflow-hidden flex-shrink-0 bg-background-100">
                  <img
                    src={app.icon}
                    alt={app.name}
                    className="w-full h-full object-cover"
                    loading="lazy"
                  />
                </div>
                <div className="flex-1 min-w-0">
                  <div className="flex items-center gap-2 mb-1">
                    <h3 className="font-semibold text-foreground-950 text-base group-hover:text-accent-600 transition-colors whitespace-nowrap">
                      {app.name}
                    </h3>
                    <span className="text-xs text-accent-500 flex items-center gap-0.5 whitespace-nowrap">
                      <i className="ri-star-fill text-xs"></i>
                      {app.rating}
                    </span>
                  </div>
                  <p className="text-xs text-foreground-600 line-clamp-2 mb-2 leading-relaxed">
                    {app.description}
                  </p>
                  <div className="flex items-center gap-3 text-xs text-foreground-500">
                    <span className="whitespace-nowrap">
                      <i className="ri-download-2-line mr-1"></i>
                      {app.downloads}
                    </span>
                    <span className="whitespace-nowrap">{app.price}</span>
                  </div>
                </div>
              </div>
              <div className="flex flex-wrap gap-1.5 mt-4">
                {app.features.slice(0, 3).map((f) => (
                  <span
                    key={f}
                    className="px-2 py-0.5 bg-background-100 text-foreground-600 rounded-md text-xs whitespace-nowrap"
                  >
                    {f}
                  </span>
                ))}
              </div>
            </Link>
          ))}
        </div>

        <div className="text-center mt-10">
          <Link
            to="/category/saishi-zhibo"
            className="inline-flex items-center gap-1.5 text-sm text-accent-600 hover:text-accent-700 font-medium transition-colors whitespace-nowrap cursor-pointer"
          >
            查看全部App
            <i className="ri-arrow-right-line"></i>
          </Link>
        </div>
      </div>
    </section>
  );
}